module.exports = __webpack_public_path__ + "img/EXV_Weinflaschen_Icons_Roseweine.e2ec2a42.svg";